import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'

const Aplicacion = () => import('../views/Aplicacion.vue')

Vue.use(VueRouter)

const routes = [
  {
    path: '/inicio',
    name: 'Home',
    component: Aplicacion,
    children: [
      {
        path: '/personal',
        name: 'Personal',
        //component: resolve => require(['../components/TablaPersonal.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "personal" */'../components/TablaPersonal.vue'),
        permisos: ["Personal"]
      },
      {
        path: '/Cursos',
        name: 'Cursos',
        //component: resolve => require(['../components/Administracion/Cursos/TablaCursos.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "Cursos" */'../components/Administracion/Cursos/TablaCursos.vue'),
        permisos: ["Personal"]
      },
      {
        path: '/CategoriaProfesional',
        name: 'CategoriaProfesional',
        //component: resolve => require(['../components/Administracion/CategoriaProfesional/TablaCategoriasProfesionales.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "CategoriaProfesional" */'../components/Administracion/CategoriaProfesional/TablaCategoriasProfesionales.vue'),
        permisos: ["Personal"]
      },
      {
        path: '/tipoContrato',
        name: 'TipoContrato',
        //component: resolve => require(['../components/Administracion/TipoContrato/TablaTiposContratos.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "TipoContrato" */'../components/Administracion/TipoContrato/TablaTiposContratos.vue')
      },
      {
        path: '/tiposVacunas',
        name: 'TiposVacunas',
        //component: resolve => require(['../components/Medicina/TipoVacuna/TablaTiposVacunas.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "TipoVacuna" */'../components/Medicina/TipoVacuna/TablaTiposVacunas.vue'),
        permisos: ["AreaMedica-PCRVacuna"]
      },
      {
        path: '/IsecoTareas',
        name: 'IsecoTareas',
        component: ()=>import(/* webpackChunkName: "IsecoTareas" */'../components/ISECO/TablaTareasIseco.vue'),
        permisos: ["IsecoControlDeTareas"]
      },
      {
        path: '/residentes',
        name: 'Residentes',
        //component: resolve => require(['../components/TablaResidentes.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "residentes" */'../components/TablaResidentes.vue')
      },
      {
        path: '/usuarios',
        name: 'Usuarios',
        //component: resolve => require(['../components/TablaUsuarios.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "usuarios" */'../components/TablaUsuarios.vue'),
        permisos: ["Usuarios"]
      },
      {
        path: '/exportarXml',
        name: 'Exportar a XML',
        //component: resolve => require(['../components/ExportarXml.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "exportarXml" */'../components/ExportarXml.vue'),
        permisos: ["ExportarXML"]
      },
      {
        path: '/importarXml',
        name: 'importar xml',
        //component: resolve => require(['../components/ImportarXml.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "exportarXml" */'../components/ImportarXml.vue'),
        permisos: ["ImportarXML"]
      },
      {
        path: '/ExportarExcel',
        name: 'ExportarExcel',
        //component: resolve => require(['../components/ExportarAExcel.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "ExportarExcel" */'../components/ExportarAExcel.vue'),
        permisos: ["ExportarExcel"]
      },
      {
        path: '/centros',
        name: 'Centros',
        //component: resolve => require(['../components/FormularioCentros.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "centros" */'../components/FormularioCentros.vue')
      },
      {
        path: '/Documentacion',
        name: 'Documentacion',
        //component: resolve => require(['../components/Documentacion.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "Documentacion" */'../components/Documentacion.vue'),
        permisos: ["AdministracionDocumentacion"]
      },
      {
        path: '/Plantillas',
        name: 'Plantillas',
        //component: resolve => require(['../components/Plantillas.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "Plantillas" */'../components/Plantillas.vue'),
        permisos: ["Plantillas"]
      },
      {
        path: '/Perfil',
        name: 'Perfil',
        //component: resolve => require(['../components/PerfilUsuario.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "Perfil" */'../components/PerfilUsuario.vue')
      },
      {
        path: '/PreIngreso',
        name: 'Pre-Ingreso',
        //component: resolve => require(['../components/Trabajo Social/Pre-ingreso.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "PreIngreso" */'../components/Trabajo Social/Pre-ingreso.vue'),
        permisos: ["PreIngreso"]
      },
      {
        path:'/Ingreso',
        name: 'Ingreso',
        //component: resolve => require(['../components/Trabajo Social/Ingreso.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "Ingreso" */'../components/Trabajo Social/Ingreso.vue'),
        permisos: ["Ingreso"]
      },
      {
        path:'/Habitaciones',
        name: 'Habitaciones',
        //component: resolve => require(['../components/Habitaciones.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "Habitaciones" */'../components/Habitaciones.vue'),
        permisos: ["Habitaciones"]
      },
      {
        path: '/TareasHabitaciones',
        name: 'TareasHabitaciones',
        //component: resolve => require(['../components/GestorHabitaciones/TareasHabitaciones.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "TareasHabitaciones" */'../components/GestorHabitaciones/TareasHabitaciones.vue'),
        permisos: ["Habitaciones_GestionDeHabitaciones"]
      },
      {
        path: '/GruposDeHabitaciones',
        name: 'GruposDeHabitaciones',
        //component: resolve => require(['../components/GestorHabitaciones/GruposDeHabitaciones.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "GruposDeHabitaciones" */'../components/GestorHabitaciones/GruposDeHabitaciones.vue'),
        permisos: ["Habitaciones_GestionDeHabitaciones"]
      },
      {
        path: '/CuadranteTareas',
        name: 'CuadranteTareas',
        //component: resolve => require(['../components/GestorHabitaciones/CuadranteTareasHabitaciones.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "CuadranteTareas" */'../components/GestorHabitaciones/CuadranteTareasHabitaciones.vue'),
        permisos: ["Habitaciones_GestionDeHabitaciones"]
      },
      {
        path: '/DocGeneral',
        name: 'DocGeneral',
        //component: resolve => require(['../components/General/DocGeneral.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "DocGeneral" */'../components/General/DocGeneral.vue'),
        permisos: ["DocumentacionUsuario"]
      },
      {
        path: '/ResidenteMedicinaComedor',
        name: 'ResidenteMedicinaComedor',
        //component: resolve => require(['../components/General/DocGeneral.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "ResidenteMedicinaComedor" */'../components/Medicina/TablaMedicinaPorComedor.vue'),
        permisos: ["TratamientosDiarios"]
      },
      {
        path: '/ResidentesSocial',
        name: 'ResidentesSocial',
        //component: resolve => require(['../components/TablaResidentes.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "ResidentesSocial" */'../components/TablaResidentes.vue')
      },
      {
        path: '/InformesSocial',
        name: 'InformesSocial',
        //component: resolve => require(['../components/Trabajo Social/Informes-Social.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "InformesSocial" */'../components/Trabajo Social/Informes-Social.vue')
      },
      {
        path: '/ResidenteMedicina',
        name: 'ResidenteMedicina',
        //component: resolve => require(['../components/Medicina/ResidentesMedicina.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "ResidenteMedicina" */'../components/Medicina/ResidentesMedicina.vue')
      },
      {
        path: '/TratamientosDiarios',
        name: 'TratamientosDiarios',
        //component: resolve => require(['../components/Medicina/TratamientosDiarios.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "TratamientosDiarios" */'../components/Medicina/TratamientosDiarios.vue'),
        permisos: ["TratamientosDiarios"]
      },
      {
        path: '/Pastilleros',
        name: 'Pastilleros',
        //component: resolve => require(['../components/Medicina/Pastilleros.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "Pastilleros" */'../components/Medicina/Pastilleros.vue'),
        permisos: ["Pastilleros"]
      },
      {
        path: '/TareasDiarias',
        name: 'TareasDiarias',
        //component: resolve => require(['../components/Gerocultores/TareasDiarias.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "TareasDiarias" */'../components/Gerocultores/TareasDiarias.vue'),
        permisos: ["Gerocultores"]
      },
      {
        path: '/CambiosPosturales',
        name: 'CambiosPosturales',
        //component: resolve => require(['../components/Gerocultores/CambiosPosturales.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "CambiosPosturales" */'../components/Gerocultores/CambiosPosturales.vue'),
        permisos: ["Gerocultores"]
      },
      {
        path: '/Absorbentes',
        name: 'Absorbentes',
        //component: resolve => require(['../components/Gerocultores/Absorbentes.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "Absorbentes" */'../components/Gerocultores/Absorbentes.vue'),
        permisos: ["Gerocultores"]
      },
      {
        path: '/Afeitado',
        name: 'Afeitado',
        //component: resolve => require(['../components/Gerocultores/Afeitado.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "Afeitado" */'../components/Gerocultores/Afeitado.vue'),
        permisos: ["Gerocultores"]
      },
      {
        path: '/AuditoriaAbsorbentes',
        name: 'AuditoriaAbsorbentes',
        //component: resolve=>require(['../components/Gerocultores/AuditoriaDeAbsorbentes.vue'],resolve)
        component: ()=>import(/* webpackChunkName: "AuditoriaAbsorbentes" */'../components/Gerocultores/AuditoriaDeAbsorbentes.vue'),
        permisos: ["Gerocultores"]
      },
      {
        path: '/Deposiciones',
        name: 'Deposiciones',
        //component: resolve=>require(['../components/Gerocultores/Deposiciones.vue'],resolve)
        component: ()=>import(/* webpackChunkName: "Deposiciones" */'../components/Gerocultores/Deposiciones.vue'),
        permisos: ["Gerocultores"]
      },
      {
        path: '/TabacoYPaga',
        name: 'TabacoYPaga',
        //component: resolve => require(['../components/Trabajo Social/TabacoYPaga.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "TabacoYPaga" */'../components/Trabajo Social/TabacoYPaga.vue'),
        permisos: ["TabacoYPaga"]
      },
      {
        path: '/Grupos/:Area',
        props: true,
        name: 'GruposResidentesBase',
        //component: resolve => require(['../components/Terapeuta Ocupacional/Grupos.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "Grupos" */'../components/Terapeuta Ocupacional/Grupos.vue'),
        permisos: ["AreaOcupacional"] 
      },
      {
        path: '/MenuYTurnos',
        name: 'MenuYTTurnos',
        //component: resolve => require(['../components/Terapeuta Ocupacional/MenuYTurnos.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "MenuYTurnos" */'../components/Terapeuta Ocupacional/MenuYTurnos.vue'),
        permisos: ["AreaOcupacional"]
      },
      {
        path: '/Actividades/:Area',
        props: true,
        name: 'Actividades',
        //component: resolve => require(['../components/Terapeuta Ocupacional/Actividades.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "Actividades" */'../components/Terapeuta Ocupacional/Actividades.vue'),
        permisos: ["AreaOcupacional"]
      },
      {
        path: '/AyudasTecnicas',
        name: 'AyudasTecnicas',
        //component: resolve => require(['../components/Fisioterapia/AyudasTecnicas.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "AyudasTecnicas" */'../components/Fisioterapia/AyudasTecnicas.vue'),
        permisos: ["AreaFisioterapia"]
      },
      {
        path: '/Proveedores',
        name: 'Proveedores',
        //component: resolve => require(['../components/Facturacion/Proveedores.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "Proveedores" */'../components/Facturacion/Proveedores.vue'),
        permisos: ["Facturacion"]
      },
      {
        path: '/TipoServicio',
        name: 'TipoServicio',
        //component: resolve => require(['../components/Facturacion/TipoServicio.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "TipoServicio" */'../components/Facturacion/TipoServicio.vue'),
        permisos: ["Facturacion"]
      },
      {
        path: '/GastosSuplidos',
        name: 'GastosSuplidos',
        //component: resolve => require(['../components/Facturacion/GastosSuplidos.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "GastosSuplidos" */'../components/Facturacion/GastosSuplidos.vue'),
        permisos: ["Facturacion"]
      },
      {
        path: '/Banco',
        name: 'Banco',
        //component: resolve => require(['../components/Facturacion/Banco.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "Banco" */'../components/Facturacion/Banco.vue'),
        permisos: ["Facturacion"]
      },
      {
        path: '/ResidentesContabilidad',
        name: 'ResidentesContabilidad',
        //component: resolve => require(['../components/Facturacion/Residentes.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "ResidentesContabilidad" */'../components/Facturacion/Residentes.vue'),
        permisos: ["Facturacion"]
      },
      {
        path: '/FormasDePago',
        name: 'FormasDePAgo',
        //component: resolve => require(['../components/Facturacion/FormasDePago.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "FormasDePago" */'../components/Facturacion/FormasDePago.vue'),
        permisos: ["Facturacion"]
      },
      {
        path: '/Familia',
        name: 'Familia',
        //component: resolve => require(['../components/Facturacion/Familia.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "Familia" */'../components/Facturacion/Familia.vue'),
        permisos: ["Facturacion"]
      },
      {
        path: '/Productos',
        name: 'Productos',
        //component: resolve => require(['../components/Facturacion/Productos.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "Productos" */'../components/Facturacion/Productos.vue'),
        permisos: ["Facturacion"]
      },
      {
        path: '/Facturas',
        name: 'Facturas',
        //component: resolve => require(['../components/Facturacion/Facturas.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "Facturas" */'../components/Facturacion/Facturas.vue'),
        permisos: ["Facturacion"]
      },
      {
        path: '/Tareas',
        name: 'Tareas',
        //component: resolve => require(['../components/Direccion/Tareas.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "Tareas" */'../components/Direccion/Tareas.vue'),
        permisos: ["Tareas"]
      },
      {
        path: '/GrupoTareas',
        name:'GrupoTareas',
        //component: resolve => require(['../components/Direccion/GrupoTareas.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "GrupoTareas" */'../components/Direccion/GrupoTareas.vue'),
        permisos: ["GrupoTareas"]
      },
      {
        path: '/Cuadrillas',
        name:'Cuadrillas',
        //component: resolve => require(['../components/Direccion/Cuadrillas.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "Cuadrillas" */'../components/Direccion/Cuadrillas.vue'),
        permisos: ["Planning"]
      },
      {
        path: '/PlantillasRepeticion',
        name:'PlantillasRepeticion',
        //component: resolve => require(['../components/Direccion/PlantillasRepeticion.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "PlantillasRepeticion" */'../components/Direccion/PlantillasRepeticion.vue'),
        permisos: ["Planning"]
      },
      {
        path: '/AsignarPlantilla',
        name:'AsignarPlantilla',
        //component: resolve => require(['../components/Direccion/AsignacionPlantilla.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "AsignarPlantilla" */'../components/Direccion/AsignacionPlantilla.vue'),
        permisos: ["Planning"]
      },
      {
        path: '/TurnosDeTrabajo',
        name:'TurnosDeTrabajo',
        //component: resolve => require(['../components/Direccion/TurnosDeTrabajo.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "TurnosDeTrabajo" */'../components/Direccion/TurnosDeTrabajo.vue'),
        permisos: ["Planning"]
      },
      {
        path: '/DocumentacionNoConformidad',
        name:'DocumentacionNoConformidad',
        //component: resolve => require(['../components/Direccion/DocumentacionDeNoConformidad/DocumentacionNoConformidad.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "DocumentacionNoConformidad" */'../components/Direccion/DocumentacionDeNoConformidad/DocumentacionNoConformidad.vue'),
        permisos: ["DocumentacionNoConformidad"]
      },
      {
        path: '/ReunionEquipoMultidisciplinar',
        name: 'ReunionEquipoMultidisciplinar',
        //component: resolve => require(['../components/Direccion/ReunionEquipoMultidisciplinar.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "ReunionEquipoMultidisciplinar" */'../components/Direccion/ReunionEquipoMultidisciplinar.vue'),
        permisos: ["ReunionesGeneralesEquipoMultidisciplinar"]
      },
      {
        path: '/ServicioRecepcion',
        name: 'ServicioRecepcion',
        //component: resolve => require(['../components/Recepcion/ServicioDeRecepcion.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "ServicioRecepcion" */'../components/Recepcion/ServicioDeRecepcion.vue'),
        permisos: ["Recepcion-Contactos"]
      },
      {
        path: '/RecepcionPersonalAjeno',
        name: 'RecepcionPersonalAjeno',
        //component: resolve => require(['../components/Recepcion/RecepcionPersonalAjeno.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "RecepcionPersonalAjeno" */'../components/Recepcion/RecepcionPersonalAjeno.vue'),
        permisos: ["Recepcion-PersonalAjeno"]
      },
      {
        path: '/Calendario',
        name: 'Calendario',
        //component: resolve => require(['../components/General/Calendario.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "Calendario" */'../components/General/Calendario.vue'),
        permisos: ["Calendario"]
      },
      {
        path: '/Mensajeria',
        name: 'Mensajeria',
        //component: resolve => require(['../components/General/MensajeriaPersonal.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "Mensajeria" */'../components/General/MensajeriaPersonal.vue'),
        permisos: ["MensajesPersonales"]
      },
      {
        path: '/VideoTutoriales',
        name: 'VideoTutoriales',
        //component: resolve => require(['../components/General/VideoTutoriales.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "VideoTutoriales" */'../components/General/VideoTutoriales.vue'),
        permisos: ["VideoTutoriales"]
      },
      {
        path: '/PreguntasFrecuentes',
        name: 'PreguntasFrecuentes',
        //component: resolve => require(['../components/General/PreguntasFrecuentes.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "PreguntasFrecuentes" */'../components/General/PreguntasFrecuentes.vue')
      },
      {
        path: '/IncidenciasMantenimientoGeneral',
        name: 'IncidenciasMantenimientoGeneral',
        //component: resolve => require(['../components/General/Incidencias.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "IncidenciasMantenimientoGeneral" */'../components/General/Incidencias.vue'),
        permisos: ["Mantenimiento"]
      },
      {
        path: '/InformesGenerales',
        name: 'InformesGenerales',
        //component: resolve => require(['../components/General/InformesGenerales.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "InformesGenerales" */'../components/General/InformesGenerales.vue'),
        permisos: ["InformesGenerales"]
      },
      {
        path: '/IncidenciasDepartamentalesGenerales',
        name: 'IncidenciasDepartamentalesGenerales',
        //component: resolve => require(['../components/General/IncidenciaGeneralDepartamentalCompleta.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "IncidenciasDepartamentalesGenerales" */'../components/General/IncidenciaGeneralDepartamentalCompleta.vue'),
        permisos: ["IncidenciasGenerales"]
      },
      {
        path: '/Ratios',
        name: 'Ratios',
        //component: resolve => require(['../components/Direccion/Ratios.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "Ratios" */'../components/Direccion/Ratios.vue'),
        permisos: ["Ratios"]
      },
      {
        path: '/GeneradorFacturas',
        name: 'GeneradorFacturas',
        //component: resolve => require(['../components/Facturacion/GeneradorFacturasDelMes.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "GeneradorFacturas" */'../components/Facturacion/GeneradorFacturasDelMes.vue'),
        permisos: ["Facturacion"]
      },
      {
        path: '/TipoIVA',
        name: 'TipoIva',
        //component: resolve => require(['../components/Facturacion/TipoIva.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "TipoIVA" */'../components/Facturacion/TipoIva.vue'),
        permisos: ["Facturacion"]
      },
      {
        path: '/IncidenciasDelDia',
        name: 'IncidenciasDelDia',
        //component: resolve => require(['../components/General/ComunicacionDeIncidencias.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "IncidenciasDelDia" */'../components/General/ComunicacionDeIncidencias.vue')
      },
      {
        path: '/ConsumosCocina',
        name: 'ConsumosCocina',
        //component: resolve => require(['../components/Cocina/ConsumosCocina.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "ConsumosCocina" */'../components/Cocina/ConsumosCocina.vue'),
        permisos: ["Cocina"]
      },
      {
        path: '/FamiliasCocina',
        name: 'FamiliasCocina',
        //component: resolve => require(['../components/Cocina/FamiliasCocina.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "FamiliasCocina" */'../components/Cocina/FamiliasCocina.vue'),
        permisos: ["Cocina"]
      },
      {
        path: '/ProductosCocina',
        name: 'ProductosCocina',
        //component: resolve => require(['../components/Cocina/ProductosCocina.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "ProductosCocina" */'../components/Cocina/ProductosCocina.vue'),
        permisos: ["Cocina"]
      },
      {
        path: '/IncidenciasGeneralCocina',
        name: 'IncidenciasGeneralCocina',
        //component: resolve => require(['../components/Cocina/IncidenciasGeneralCocina.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "IncidenciasGeneralCocina" */'../components/Cocina/IncidenciasGeneralCocina.vue'),
        permisos: ["Cocina"]
      },
      {
        path: '/ProveedoresCocina',
        name: 'ProveedoresCocina',
        //component: resolve => require(['../components/Cocina/ProveedoresCocina.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "ProveedoresCocina" */'../components/Cocina/ProveedoresCocina.vue'),
        permisos: ["Cocina"]
      },
      {
        path: '/RecetasCocina',
        name: 'RecetasCocina',
        //component: resolve => require(['../components/Cocina/Recetas.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "RecetasCocina" */'../components/Cocina/Recetas.vue'),
        permisos: ["Cocina"]
      },
      {
        path: '/MenuCocina',
        name: 'MenuCocina',
        //component: resolve => require(['../components/Cocina/Menu.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "MenuCocina" */'../components/Cocina/Menu.vue'),
        permisos: ["Cocina"]
      },
      {
        path: '/PeriodicidadMenuCocina',
        name: 'PeriodicidadMenuCocina',
        //component: resolve => require(['../components/Cocina/MenuPeriodicos.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "PeriodicidadMenuCocina" */'../components/Cocina/MenuPeriodicos.vue'),
        permisos: ["Cocina"]
      },
      {
        path: '/ElaboracionYServicioDeComidas',
        name: 'ElaboracionYServicioDeComidas',
        //component: resolve => require(['../components/Cocina/ElaboracionYServicioDeComidas.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "ElaboracionYServicioDeComidas" */'../components/Cocina/ElaboracionYServicioDeComidas.vue'),
        permisos: ["Cocina"]
      },
      {
        path: '/ControlTemperaturasEquipos',
        name: 'ControlTemperaturasEquipos',
        //component: resolve => require(['../components/Cocina/ControlTemperaturasEquipo.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "ControlTemperaturasEquipos" */'../components/Cocina/ControlTemperaturasEquipo.vue'),
        permisos: ["Cocina"]
      },
      {
        path: '/PlanDeEliminacionDeResiduos',
        name: 'PlanDeEliminacionDeResiduos',
        //component: resolve => require(['../components/Cocina/PlanDeEliminacionDeResiduos.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "PlanDeEliminacionDeResiduos" */'../components/Cocina/PlanDeEliminacionDeResiduos.vue'),
        permisos: ["Cocina"]
      },
      {
        path: '/ControlPlanDeLimpiezaYDesinfeccion',
        name: 'ControlPlanDeLimpiezaYDesinfeccion',
        //component: resolve => require(['../components/HigieneYDesinfeccion/ControlPlanDeLimpiezaYDesinfeccion.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "ControlPlanDeLimpiezaYDesinfeccion" */'../components/HigieneYDesinfeccion/ControlPlanDeLimpiezaYDesinfeccion.vue'),
        permisos: ["HigieneYDesinfeccion"]
      },
      {
        path: '/RegistroDeEjecucionDelPlanDeMantenimiento',
        name: 'RegistroDeEjecucionDelPlanDeMantenimiento',
        //component: resolve => require(['../components/HigieneYDesinfeccion/RegistroEjecucionPlanDeMantenimiento.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "RegistroDeEjecucionDelPlanDeMantenimiento" */'../components/HigieneYDesinfeccion/RegistroEjecucionPlanDeMantenimiento.vue'),
        permisos: ["HigieneYDesinfeccion"]
      },
      {
        path: '/ControlDeCloroEnAguaYCaracteristiasOrganolepticas',
        name: 'ControlDeCloroEnAguaYCaracteristiasOrganolepticas',
        //component: resolve => require(['../components/HigieneYDesinfeccion/ControlDeCloroEnAguaYCaracteristiasOrganolepticas.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "ControlDeCloroEnAguaYCaracteristiasOrganolepticas" */'../components/HigieneYDesinfeccion/ControlDeCloroEnAguaYCaracteristiasOrganolepticas.vue'),
        permisos: ["HigieneYDesinfeccion"]
      },
      {
        path: '/RegistroDeCloroResidual',
        name: 'RegistroDeCloroResidual',
        //component: resolve => require(['../components/HigieneYDesinfeccion/RegistroDeCloroResidual.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "RegistroDeCloroResidual" */'../components/HigieneYDesinfeccion/RegistroDeCloroResidual.vue'),
        permisos: ["HigieneYDesinfeccion"]
      },
      {
        path: '/RegistroDeControlDePlaga',
        name: 'RegistroDeControlDePlaga',
        //component: resolve => require(['../components/HigieneYDesinfeccion/RegistroDeControlDePlaga.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "RegistroDeControlDePlaga" */'../components/HigieneYDesinfeccion/RegistroDeControlDePlaga.vue'),
        permisos: ["HigieneYDesinfeccion"]
      },
      {
        path: '/PlanDeActuacionGeneralGeneralPsicologia',
        name: 'PlanDeActuacionGeneralGeneralPsicologia',
        //component: resolve => require(['../components/Psicologia/PlanDeActuacionGeneralGeneralPsicologia.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "PlanDeActuacionGeneralGeneralPsicologia" */'../components/Psicologia/PlanDeActuacionGeneralGeneralPsicologia.vue'),
        permisos: ["AreaPsicologia-PlanActuacion"]
      },
      {
        path: '/EscalasGeneralPsicologia',
        name: 'EscalasGeneralPsicologia',
        //component: resolve => require(['../components/Psicologia/EscalasGeneralPsicologia.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "EscalasGeneralPsicologia" */'../components/Psicologia/EscalasGeneralPsicologia.vue'),
        permisos: ["AreaPsicologia-Escalas"]
      },
      {
        path: '/IncidenciasGeneralPsicologia',
        name: 'IncidenciasGeneralPsicologia',
        //component: resolve => require(['../components/Psicologia/IncidenciasGeneralPsicologia.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "IncidenciasGeneralPsicologia" */'../components/Psicologia/IncidenciasGeneralPsicologia.vue'),
        permisos: ["AreaPsicologia-Incidencias"]
      },
      {
        path: '/ChatDepartamental',
        name: 'ChatDepartamental',
        //component: resolve => require(['../components/General/NuevoChatDepartamental.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "ChatDepartamental" */'../components/General/NuevoChatDepartamental.vue'),
        permisos: ["MensajesDepartamento"]
      },
      {
        path: '/GruposDeResidentesAdm',
        name: 'GruposDeResidentes',
        //component: resolve => require(['../components/Administracion/GruposDeResidenteAdm.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "GruposDeResidentesAdm" */'../components/Administracion/GruposDeResidenteAdm.vue'),
        permisos: ["GruposDeResidentesAdm"]
      },
      {
        path: '/Familiares',
        name: 'Familiares',
        component: ()=>import(/* webpackChunkName: "Familiares" */'../components/Administracion/Familiares/Familiares.vue')
      },
      {
        path: '/IncidenciasGeneralMedicina',
        name: 'IncidenciasGeneralMedicina',
        //component: resolve => require(['../components/Medicina/IncidenciasGeneralMedicina.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "IncidenciasGeneralMedicina" */'../components/Medicina/IncidenciasGeneralMedicina.vue'),
        permisos: ["AreaMedica-Incidencias"]
      },
      {
        path: '/SujeccionesGenerales',
        name: 'SujeccionesGenerales',
        //component: resolve => require(['../components/Gerocultores/SujeccionesGenerales/SujeccionesGenerales.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "SujeccionesGenerales" */'../components/Gerocultores/SujeccionesGenerales/SujeccionesGenerales.vue'),
        permisos: ["Gerocultores-Sujeciones"]
      },
      {
        path: '/IncidenciasGeneralDireccion',
        name: 'IncidenciasGeneralDireccion',
        //component: resolve => require(['../components/Direccion/IncidenciasGeneralDireccion.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "IncidenciasGeneralDireccion" */'../components/Direccion/IncidenciasGeneralDireccion.vue'),
        permisos: ["Residente_Direccion_Incidencias"]
      },
      {
        path: '/IncidenciasGeneralTerapiaOcupacional',
        name: 'IncidenciasGeneralTerapiaOcupacional',
        //component: resolve => require(['../components/Terapeuta Ocupacional/IncidenciasGeneralTerapiaOcupacional.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "IncidenciasGeneralTerapiaOcupacional" */'../components/Terapeuta Ocupacional/IncidenciasGeneralTerapiaOcupacional.vue'),
        permisos: ["AreaOcupacional-Incidencias"]
      },
      {
        path: '/IncidenciasGeneralFisioterapia',
        name: 'IncidenciasGeneralFisioterapia',
        //component: resolve => require(['../components/Fisioterapia/IncidenciasGeneralFisioterapia.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "IncidenciasGeneralFisioterapia" */'../components/Fisioterapia/IncidenciasGeneralFisioterapia.vue'),
        permisos: ["AreaFisioterapia-Incidencias"]
      },
      {
        path: '/IncidenciasGeneralGerocultoria',
        name: 'IncidenciasGeneralGerocultoria',
        //component: resolve => require(['../components/Gerocultores/IncidenciasGeneralGerocultoria.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "IncidenciasGeneralGerocultoria" */'../components/Gerocultores/IncidenciasGeneralGerocultoria.vue'),
        permisos: ["Gerocultores-Incidencias"]
      },
      {
        path: '/IncidenciasGeneralTrabajoSocial',
        name: 'IncidenciasGeneralTrabajoSocial',
        //component: resolve => require(['../components/Trabajo Social/IncidenciasGeneralTrabajoSocial.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "IncidenciasGeneralTrabajoSocial" */'../components/Trabajo Social/IncidenciasGeneralTrabajoSocial.vue'),
        permisos: ["AreaSocial-Incidencias"]
      },
            {
        path: '/IncidenciasGeneralRecepcion',
        name: 'IncidenciasGeneralRecepcion',
        //component: resolve => require(['../components/Recepcion/IncidenciasGeneralRecepcion.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "IncidenciasGeneralRecepcion" */'../components/Recepcion/IncidenciasGeneralRecepcion.vue'),
        permisos: ["Recepcion-Incidencias"]
      },
      {
        path: '/Zonas',
        name: 'Zonas',
        //component: resolve => require(['../components/Mantenimiento/Zonas/TablaZonas.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "Zonas" */'../components/Mantenimiento/Zonas/TablaZonas.vue'),
        permisos: ["Mantenimiento"]
      },
      {
        path: '/TipoIncidenciaMantenimiento',
        name: 'TipoIncidenciaMantenimiento',
        //component: resolve => require(['../components/Mantenimiento/TipoIncidenciaMantenimiento/TablaTipoIncidenciaMantenimiento.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "TipoIncidenciaMantenimiento" */'../components/Mantenimiento/TipoIncidenciaMantenimiento/TablaTipoIncidenciaMantenimiento.vue'),
        permisos: ["Mantenimiento"]
      },
      {
        path: '/InstalaccionInspeccionMantenimientos',
        name: 'InstalaccionInspeccionMantenimientos',
        //component: resolve => require(['../components/Mantenimiento/InstalaccionInspeccionMantenimiento/TablaInstalaccionInspeccionMantenimientos.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "InstalaccionInspeccionMantenimientos" */'../components/Mantenimiento/InstalaccionInspeccionMantenimiento/TablaInstalaccionInspeccionMantenimientos.vue'),
        permisos: ["Mantenimiento"]
      },
      {
        path: '/TipoRevisionInternaMantenimiento',
        name: 'TipoRevisionInternaMantenimiento',
        //component: resolve => require(['../components/Mantenimiento/TipoRevisionInternaMantenimiento/TablaTipoRevisionInternaMantenimiento.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "TipoRevisionInternaMantenimiento" */'../components/Mantenimiento/TipoRevisionInternaMantenimiento/TablaTipoRevisionInternaMantenimiento.vue'),
        permisos: ["Mantenimiento"]
      },
      {
        path: '/InspeccionesExternas',
        name: 'InspeccionesExternas',
        //component: resolve => require(['../components/Mantenimiento/Inspecciones Externas/InspeccionesExternas.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "InspeccionesExternas" */'../components/Mantenimiento/Inspecciones Externas/InspeccionesExternas.vue'),
        permisos: ["Mantenimiento"]
      },
      {
        path: '/InspeccionesInternas',
        name: 'InspeccionesInternas',
        //component: resolve => require(['../components/Mantenimiento/InspeccionesInternas/InspeccionesInternas.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "InspeccionesInternas" */'../components/Mantenimiento/InspeccionesInternas/InspeccionesInternas.vue'),
        permisos: ["Mantenimiento"]
      },
      {
        path: '/IncidenciasMantenimiento',
        name: 'IncidenciasMantenimiento',
        //component: resolve => require(['../components/Mantenimiento/Incidencias/Incidencias.vue'], resolve)
        component: ()=>import(/* webpackChunkName: "IncidenciasMantenimiento" */'../components/Mantenimiento/Incidencias/Incidencias.vue')
      },
    ]
  },
  {
    path: '/',
    name: 'Inicio',
    //component: resolve => require(['../views/VistaInicial.vue'], resolve)
    component: ()=>import(/* webpackChunkName: "Inicio" */'../views/VistaInicial.vue')
  },
  {
    path: '/login',
    name: 'Login',
    //component: resolve => require(['../views/Login.vue'], resolve),
    component: ()=>import(/* webpackChunkName: "Login" */'../views/Login.vue')
  },
  /*{
    path: '/login',
    name: 'Login',
    component: resolve => require(['../views/InicioSesion.vue'], resolve),
  },*/
  {
    path: '/changePassword',
    name: 'CambioContraseña',
    //component: resolve => require(['../views/CambioContraseña.vue'], resolve)
    component: ()=>import(/* webpackChunkName: "changePassword" */'../views/CambioContraseña.vue')
  },
  {
    path: '/Verificacion/:Token',
    props: true,
    name: 'Verificacion',
    //component: resolve => require(['../components/ComponentesAuxiliares/Verificacion.vue'], resolve)
    component: ()=>import(/* webpackChunkName: "Verificacion" */'../components/ComponentesAuxiliares/Verificacion.vue')
  },
  {
    path: '/redirect',
    props: true,
    name: 'redirect',
    //component: resolve => require(['../components/ComponentesAuxiliares/redirect.vue'], resolve)
    component: ()=>import(/* webpackChunkName: "redirect" */'../components/ComponentesAuxiliares/redirect.vue')
  },
  {
    path: '/VideoPrueba',
    name: 'VideoPrueba',
    //component: resolve => require(['../components/ComponentesAuxiliares/videoPrueba.vue'], resolve)
    component: ()=>import(/* webpackChunkName: "VideoPrueba" */'../components/ComponentesAuxiliares/videoPrueba.vue')
  },
  {
    path: '/403',
    name: '403',
    //component: resolve => require(['../components/Errores/403.vue'], resolve)
    component: ()=>import(/* webpackChunkName: "403" */'../components/Errores/403.vue')
  },
  {
    path: '/404',
    name: '404',
    //component: resolve => require(['../components/Errores/404.vue'], resolve),
    component: ()=>import(/* webpackChunkName: "404" */'../components/Errores/404.vue')
  },
  {
      path:'*',
      redirect:{
          name:"404"
      }
  }
  /*{
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about"  '../views/About.vue')
  },*/
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router